/* 收款相关 */
/* keepAlive:该页面是否缓存 */
export default [
    {
        path: 'payment/receivables',
        name: 'receivables',
        meta: {
            title: '',
        },
        component: () => import('@/views/payment/receivables.vue')
    },
    {
        path: 'payment/success',
        name: 'paySuccess',
        meta: {
            title: '',
        },
        component: () => import('@/views/payment/success.vue')
    },//购买成功页
    {
        path: 'payment/other',
        name: 'payOther',
        meta: {
            title: '找人代付',
        },
        component: () => import('@/views/payment/other.vue')
    },//他人代付页
    {
        path: 'payment/otherResult',
        name: 'payOtherResult',
        meta: {
            title: '找人代付',
        },
        component: () => import('@/views/payment/otherResult.vue')
    },//他人代付结果页
]